import { render } from "./AddFaqPage.vue?vue&type=template&id=ea831d9e&ts=true"
import script from "./AddFaqPage.vue?vue&type=script&lang=ts"
export * from "./AddFaqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__